module.exports = __webpack_public_path__ + "static/media/icon_whatsapp.953a8c3e.png";